import React, { useState } from "react";
import { Modal, Button as RBButton } from 'react-bootstrap';
import Hack4tts_Intro from "./Hack4tts_Intro"; // update path accordingly
import application_contants from '../../../contants/application_contants'; 

function Hack4TTSModalPopup() {
  const [show, setShow] = useState(false);

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  return (
    <>
    <div className="registers-container">
      {/* <Button onClick={handleShow} className="regist-btn-outline">
        Click Here for more info
      </Button>  */}
      <a onClick={handleShow} className="regist-btn-outline">
        Read More
      </a> 
    </div>

      <Modal show={show} onHide={handleClose} size="lg"  className="custom-only-close">
        {/* NOTE: no `closeButton` prop here */}
        <Modal.Header className="position-relative">
          <Modal.Title>Voice Tech for All: Introduction</Modal.Title>

          {/* Your custom close button */}
          <button
            type="button"
            className="modal-close-btn"
            onClick={handleClose}
            aria-label="Close"
          >
            <img src={application_contants.CLOSEIMG} alt="Close" className="modal-close-img" />
          </button>
        </Modal.Header>

        <Modal.Body>
          <Hack4tts_Intro />
        </Modal.Body>

        <Modal.Footer>
          <RBButton variant="secondary" onClick={handleClose}>
            Close
          </RBButton>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default Hack4TTSModalPopup;
